module.exports = __webpack_public_path__ + "static/media/div1sammandrag.4e1b3f05.jpg";